'use strict';

import React from 'react';

import classnames from 'classnames';
import { OTLink } from '../../tag/OTLink';
import { formatDate, formatTime } from '../../../utils/TimeUtils';
import OTButton from '../../tag/OTButton';
import WindowUtils from '../../../utils/WindowUtils';
import OTIcon from '../../tag/OTIcon';
import { getDepartmentDisplay } from '../../../utils/TimelineUtils';
import BaseQuestionnaireListItem from '../BaseQuestionnaireListItem';
import { getLogo } from '../../../utils/LogoUtils';
import { FormattedMessage, injectIntl } from 'react-intl';

const { id: module_id } = module;

class QuestionnaireListItem extends React.Component {
  onClick = () => {
    const { link } = this.props.data;
    WindowUtils.navigate('#/questionnaires' + link);
  };

  render() {
    const { intl } = this.props;
    let {
      name,
      link,
      answerDateTime,
      description,
      status,
      endDateTime,
      appointmentData,
      category,
    } = this.props.data;
    let leftDate,
      rightDate = null;
    let past = false;
    let unitLogo = null;
    if (category === 'sydansairaala') {
      let logoAttr = getLogo('SYDAN');
      unitLogo = (
        <img
          className="ot-queryitem__logo"
          alt={intl.formatMessage({ id: logoAttr.altTextId })}
          src={logoAttr.logoSrc}
        />
      );
    }

    if (status !== 'COMPLETED' && endDateTime) {
      leftDate = <span>Täytä viimeistään {formatDate(endDateTime)}</span>;
    }

    if (status === 'COMPLETED') {
      past = true;
      rightDate = <span>Vastattu {formatDate(answerDateTime)}</span>;
    }

    if (appointmentData) {
      name = (
        <FormattedMessage
          id={`${module_id}.questionnaire.with.appointment`}
          values={{
            name: name,
            department: getDepartmentDisplay(appointmentData.department),
            date: formatDate(appointmentData.date),
            time: formatTime(appointmentData.date),
          }}
        />
      );
    }

    return (
      <BaseQuestionnaireListItem
        left={
          <>
            {status === 'COMPLETED' || status === 'MODIFIABLE' ? (
              <OTLink
                className={'ot-queryitem__name completed'}
                link={'/questionnaires' + link}
              >
                {name}
              </OTLink>
            ) : (
              <span className={'ot-queryitem__name'}>{name}</span>
            )}
            {description && (
              <>
                <br />
                <span
                  className={classnames('ot-queryitem__description', {
                    completed: status === 'COMPLETED',
                  })}
                >
                  <OTIcon
                    config={{
                      type: 'custom',
                      name: 'palaute',
                      color: 'darkblue',
                    }}
                    style={{
                      height: '13px',
                      width: '15px',
                      marginRight: '5px',
                    }}
                  />
                  {description}
                </span>
              </>
            )}
          </>
        }
        center={leftDate}
        right={
          <>
            {status === 'ACTIVE' || status === 'STARTED' ? (
              <OTButton
                color={'light'}
                className={'pull-right ot-queryitem__button'}
                onClick={this.onClick}
              >
                <OTIcon
                  config={{ type: 'fa', name: 'icon-pencil' }}
                  style={{ marginRight: '8px' }}
                />
                <FormattedMessage id={'fill'} />
              </OTButton>
            ) : (
              <span className={'pull-right ot-queryitem__answered'}>
                <OTIcon
                  config={{ type: 'fa', name: 'icon-ok' }}
                  style={{ marginRight: '8px' }}
                />
                {rightDate}
              </span>
            )}
            <span
              className={classnames('ot-queryitem__logo', {
                past: past,
              })}
            >
              {unitLogo}
            </span>
          </>
        }
      />
    );
  }
}

export default injectIntl(QuestionnaireListItem);
